'use client';

import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

import {
	type CareerOfferForm,
	createCareerOfferFormTracker,
	getCareerOfferTechnology,
	useCareerOfferAnalytics,
} from '@/features/career-offer-analytics';

export function useOfferFormAnalytics(form: CareerOfferForm) {
	const analytics = useCareerOfferAnalytics();
	const pathname = usePathname();
	const technology = getCareerOfferTechnology(pathname);

	return useMemo(
		() => createCareerOfferFormTracker(form, technology, analytics),
		[analytics, form, technology],
	);
}
